import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router } from '@angular/router';
import { MdDialog } from '@angular/material';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DaterangepickerConfig } from 'ng2-daterangepicker';

import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { dialogComponent } from '../dialog/dialog.component';
import { CommonService } from '../shared/services/common.service';
import { LoaderService } from '../loader/loader.service';
import { APPCONFIG } from '../config';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { FileUploader } from 'ng2-file-upload';





@Component({
  selector: 'app-foc-dashboard',
  template: require('./foc-dashboard.component.html'),
  styles: [require('./foc-dashboard.component.scss')],
  providers: [HttpService, SessionHandler]
})
export class FocDashboardComponent implements OnInit,AfterViewInit {
  @ViewChild('table') table: DatatableComponent;

  rows: any[] = [];
  allRowsSnapshot: any[] = [];
  page = { pageNumber: 1, size: 20, total: 0, totalPages: 0 };
  searchValue = '';

  // UI flags
  showTable = true;
  showFilterList = false;

  // date text (cosmetic)
  currentDateRange = '';
  fileUrl: any;
  fileURL: any = APPCONFIG.appUrlBase + '/focExtractFile';
  
  tableScrolled: boolean = false;
private scrollTimer: any;


  // services / session
  userData: any;
  dialogRef: any;

  // advanced search state
  customFilters: any = {};
  arrayKeys: string[] = [];
  reasonList: any[] = [];
  currentAdvancedFilter: any = null;

  // roles
  isAdmin = false;
  isOTD = false;
  isOrderDesk = false;
  isEndConsumner = false;
  isApprover = false;
  dashboardData: any;
  isFOC_Admin = false;
  isFOC_Approver = false;
  isFOC_HR = false;
  isFOC_Employee = false;
  isFocOrder = false;
  isFOC_Display = false;
  isDisplayOnlyUser = false;
  private isLoadingPage = false;
  private lastRequestedPage = 1;
  canShowActionColumn: boolean = false;

  
  

  constructor(
    private http: HttpService,
    private sessionHandler: SessionHandler,
    private router: Router,
    private dialog: MdDialog,
    private commonService: CommonService,
    private LoaderService: LoaderService,
    private http1: Http
  ) {

    if (!this.http.checkSession()) {
      this.http.showSessionError();
      return;
    }

    this.userData = JSON.parse(this.sessionHandler.getItem('loginData') || '{}');

    

    const roles: string[] =
    (this.userData && Array.isArray(this.userData.role)) ? this.userData.role : [];
  
 // FOC roles
    this.isFOC_Admin = roles.indexOf('FOC_ADMINISTRATOR') !== -1;
    this.isFOC_Approver  = roles.indexOf('FOC_APPROVER') !== -1;
    this.isFOC_HR = roles.indexOf('FOC_HR') !== -1;
    this.isFOC_Employee  = roles.indexOf('FOC_EMPLOYEE') !== -1;
    this.isFOC_Display   = roles.indexOf('FOC_DISPLAY') !== -1;
  // count only FOC roles
    const focRoles = roles.filter(
      r => r === 'FOC_ADMINISTRATOR' || 
           r === 'FOC_APPROVER' ||  
           r === 'FOC_HR' ||  
           r === 'FOC_EMPLOYEE' || 
           r === 'FOC_DISPLAY');
  // display-only user
  this.isDisplayOnlyUser = focRoles.length === 1 && focRoles[0] === 'FOC_DISPLAY';
  this.isFocOrder = this.isFOC_Admin || this.isFOC_Approver ||  this.isFOC_HR || this.isFOC_Employee ||  this.isFOC_Display;

    if (this.userData && this.userData.role && this.userData.role.length > 0) {
      this.isAdmin = this.userData.role.indexOf('ADMIN') !== -1;
      this.isOTD = this.userData.role.indexOf('FOC_APPROVER') !== -1 || this.userData.role.indexOf('OTD_APPROVER') !== -1;
      this.isOrderDesk = this.userData.role.indexOf('ORDER_DESK_AGENT') !== -1;
      this.isEndConsumner = this.userData.role.indexOf('END_CONSUMER') !== -1;
      this.isApprover = this.userData.role.indexOf('APPROVER') !== -1;
    }

    console.log("user data", this.userData)


    const today = new Date();
    const monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const start = new Date(today.getFullYear(), Math.max(0, today.getMonth()-1), today.getDate());
    const end = new Date(today.getFullYear(), Math.min(11, today.getMonth()+1), today.getDate());
    this.currentDateRange = monthNames[start.getMonth()] + ' ' + start.getDate() + ' ' + start.getFullYear() + ' - ' +
                            monthNames[end.getMonth()] + ' ' + end.getDate() + ' ' + end.getFullYear();

    // subscribe to advanced search results (commonService)
    if (this.commonService && this.commonService.searchChange) {
      this.commonService.searchChange.pipe(
        filter((v: any) => !!v && !!v.filters)
      ).subscribe((value: any) => {
        if (value && value.display && value.filters) {
          this.applyAdvancedFilters(value);
        }
      });
    }

    try {
      const reasons = this.sessionHandler.getItem('reasons');
      if (reasons) this.reasonList = JSON.parse(reasons);
    } catch (e) {
      this.reasonList = [];
    }
  }

  ngOnInit() {
    this.canShowActionColumn =
    !this.isFOC_Display &&
  (this.isFOC_Admin ||
  this.isFOC_Approver ||
  (
    !this.isFOC_Employee &&
    !this.isFOC_HR
  ));

  }
  ngAfterViewInit(): void {
  this.fetchPage(1, this.page.size, '');
}

 

  

  fetchPage(pageNum: number, size: number, status: string = '', extraFilters: any = null) {
    // mark loading
    this.isLoadingPage = true;
  
    let params = 'page=' + pageNum + '&size=' + size;
    if (status) params += '&status=' + encodeURIComponent(status);
  
    const url = 'focApi/v1/getFOCRequestList?' + params;
  
    // ADVANCED SEARCH → send filters as POST body
    if (extraFilters) {
      this.http.postRequest(extraFilters, url).subscribe(
        (res: any) => {
          this.page.pageNumber = pageNum;
          this.mapResponseToRows(res);

          this.isLoadingPage = false;
          this.http.onEnd();
          
        },
        err => {
          this.isLoadingPage = false;

          console.error('Failed to fetch FOC requests', err);
          if (err && err.status != 0) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Failed to load FOC requests.';
          }
          this.http.onEnd();
        }
      );
      return;
    }
  

    // DEFAULT DASHBOARD → same API but with empty JSON body
    const emptyBody = {};
  
    this.http.postRequest(emptyBody, url).subscribe(
      (res: any) => {
  this.page.pageNumber = pageNum;
  this.mapResponseToRows(res);

  this.isLoadingPage = false;
  this.http.onEnd();
  
},
      err => {
        this.isLoadingPage = false;

        console.error('Failed to fetch FOC requests', err);
        if (err && err.status != 0) {
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg = 'Failed to load FOC requests.';
        }
        this.http.onEnd();
      }
    );
  }
  
  changePageSize(size: number) {
  this.page.size = Number(size);
  this.page.pageNumber = 1;

  this.fetchPage(
    1,
    this.page.size,
    '',
    this.currentAdvancedFilter
  );
}

  private mapResponseToRows(res: any) {
    this.dashboardData = res;
    const list = (res && (res.FOCRequestList || res.items)) ? (res.FOCRequestList || res.items) : [];
    const mapped: any[] = [];
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      mapped.push(this.mapItemToRow(item));
    }
    this.rows = mapped;
    // deep clone snapshot so later filterDatatable can restore original list
    this.allRowsSnapshot = JSON.parse(JSON.stringify(this.rows));
    this.page.total = res && (res.total || res.itemCount) ? parseInt(res.total || res.itemCount, 10) : this.rows.length;
    this.page.size = res && res.size ? res.size : this.page.size;
    // this.page.pageNumber = res && (res.page || res.pageNumber) ? (res.page || res.pageNumber) : 1;
    this.page.totalPages = res && res.totalPages ? res.totalPages : 1;

    // // ngx-datatable expects zero-based offset
    // if (this.table) {
    //   this.table.offset = (this.page.pageNumber - 1);
    // }
  }
  

  private mapItemToRow(item: any) {
    return {
      Id: item.id || item.orderId,
      sapFOCNo: item.sapFOCNo || item.sapOrderId,
      orderId: item.sapFOCNo || item.sapOrderId || item.orderId,
      soldTo: item.soldTo || item.tradePartnerId,
      creationDate: item.createdOn || item.creationDate || item.entryDate,
      createdBy: item.createdBy,
      orderReason: item.returnReasonDesc || item.orderReason || item.reason,
      status: item.status,
      approver: item.level2Approver || item.level1Approver,
      approvalDate: item.actionDate || item.approvalDate || item.entryDate,
      cost: item.cost,
      currency: item.currency || '',
      level1Reviewer: item.level1Reviewer,
      level2Reviewer: item.level2Reviewer,
      original: item,
      firstName:item.firstName,
      companyName:item.companyName
    };
  }
  

  onPage(event: any): void {
  if (
    !event ||
    event.offset === undefined ||
    event.offset === null
  ) {
    return;
  }

  const currentOffset = this.page.pageNumber - 1;
  const requestedOffset = Number(event.offset);

  /*
   * ngx-datatable emits page events during horizontal scrolling.
   * Restore the current offset immediately, without setTimeout.
   */
  if (this.tableScrolled) {
    if (this.table) {
      this.table.offset = currentOffset;
    }
    return;
  }

  /*
   * Sometimes the page event is emitted before the scroll event,
   * so tableScrolled may still be false. Protect against offset 0.
   */
  if (
    requestedOffset === 0 &&
    currentOffset > 0
  ) {
    if (this.table) {
      this.table.offset = currentOffset;
    }
    return;
  }

  if (this.isLoadingPage) {
    if (this.table) {
      this.table.offset = currentOffset;
    }
    return;
  }

  const pageNumber = requestedOffset + 1;

  if (pageNumber === this.page.pageNumber) {
    return;
  }

  this.page.pageNumber = pageNumber;

  this.fetchPage(
    pageNumber,
    this.page.size,
    '',
    this.currentAdvancedFilter
  );
}
  
  
  

  // client-side global filter across key visible columns
  filterDatatable(term: string) {
    this.searchValue = term || '';
    const t = (this.searchValue || '').toLowerCase().trim();
    if (!t) {
      // use slice() to create shallow copy instead of spread operator
      this.rows = this.allRowsSnapshot.slice();
      return;
    }

    const filtered: any[] = [];
    for (let i = 0; i < this.allRowsSnapshot.length; i++) {
      const r = this.allRowsSnapshot[i];
      const matches =
        (r.orderId && String(r.orderId).toLowerCase().indexOf(t) !== -1) ||
        (r.soldTo && String(r.soldTo).toLowerCase().indexOf(t) !== -1) ||
        (r.createdBy && String(r.createdBy).toLowerCase().indexOf(t) !== -1) ||
        (r.orderReason && String(r.orderReason).toLowerCase().indexOf(t) !== -1) ||
        (r.status && String(r.status).toLowerCase().indexOf(t) !== -1);
      if (matches) filtered.push(r);
    }
    this.rows = filtered;
  }

  // route to create FOC request
  //passing query param fresh to clear the data when first navigate from create page 
  navigateToCreate() {
    this.commonService.setData(null);
    this.router.navigate(['/app/focrequests/create'],
      { queryParams: { fresh: '1' } }
    ); 
  }

  // open detail using your HttpService getRequest (focApi/v1/getFOCRequestDetail?FOCId=1)
  openDetail(row) {
    this.router.navigate(['/app/foc-view/confirm', row.Id]);
  }

  copiedOrderId: string = null;
  hoveredOrderId: string = null;



  copyOrderId(event: MouseEvent, orderId: string) {
    event.stopPropagation();
  
    var textarea = document.createElement('textarea');
    textarea.value = orderId;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  
    this.copiedOrderId = orderId;
  
    setTimeout(() => {
      this.copiedOrderId = null;
    }, 1500);
  }
  
  
  
  
  
  

  // Confirm + perform approve/reject. You must supply the real backend endpoint to replace the TODO.
  confirmAction(row, action: 'approve'|'reject') {
    const verb = action === 'approve' ? 'APPROVE' : 'REJECT';
    this.dialogRef = this.dialog.open(dialogComponent);
    this.dialogRef.componentInstance.msg = 'Are you sure you want to ' + verb + ' this request?';
    this.dialogRef.componentInstance.isConfirm = true;
    this.dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
  
      // determine current status (prefer original status if available)
      const currentStatusRaw = (row.original && row.original.status) ? row.original.status : row.status;
      const currentStatus = currentStatusRaw ? String(currentStatusRaw).trim().toUpperCase() : '';
  
      // determine new status according to your rule
      let newStatus: string;
      if (action === 'reject') {
        newStatus = 'REJECTED';
      } else {
        // approve: move to next level — if already LEVEL1_APPROVED -> LEVEL2_APPROVED
        // otherwise set LEVEL1_APPROVED
        newStatus = (currentStatus === 'LEVEL1_APPROVED') ? 'LEVEL2_APPROVED' : 'LEVEL1_APPROVED';
      }
  
      // build payload to match backend expectation
      const makeYYYYMMDD = (d: Date) => {
        const yyyy = d.getFullYear();
        const mm = ('0' + (d.getMonth() + 1)).slice(-2);
        const dd = ('0' + d.getDate()).slice(-2);
        return '' + yyyy + mm + dd;
      };
  
      const payload: any = {
        focId: row.Id,
        status: newStatus,
        email: this.userData && this.userData.email ? this.userData.email : null,
        userId: this.userData && this.userData.userId ? this.userData.userId : null,
        approvalDate: makeYYYYMMDD(new Date())
      };
  
      this.http.postRequest(payload, 'focApi/v1/updateFOCStatus').subscribe(
        (res: any) => {
          this.http.onEnd();
  
          const okCondition = res && (res.status === 'Success' || res.responseCode === 200 || res.success);
          if (okCondition) {
            // update UI model (both displayed status and original payload)
            row.status = newStatus;
            this.fetchPage(this.page.pageNumber, this.page.size,'',this.currentAdvancedFilter);
            if (row.original) row.original.status = newStatus;
  
            const ok = this.dialog.open(dialogComponent);
            ok.componentInstance.msg = 'Request ' + (action === 'approve' ? 'approved' : 'rejected') + ' successfully.';
          } else {
            const errDlg = this.dialog.open(dialogComponent);
            errDlg.componentInstance.msg = (res && res.errorMessage) ? res.errorMessage : 'Failed to process request. Please contact administrator.';
          }
        },
        err => {
          console.error('Approve/Reject error', err);
          if (err && err.status != 0) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = err;
          }
          this.http.onEnd();
        }
      );
    });
  }
  

  public showLoader(): void {
          this.LoaderService.show();
      }

      public hideLoader(): void {
        this.LoaderService.hide();
    }

  // public extractFile() {
  //         this.showLoader();
  //         this.getFile(this.fileURL).subscribe(fileData => {
  //             this.hideLoader();
  //             let fileName = "extract_file_" + Date.now() + ".xlsx";
  //             var file = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;' });
  //             saveAs(file, fileName);
  //         });
  //         //this.http.onEnd();
          
  //     }

  //     public getFile(path: string): Observable<any> {
  //       let temp_dashboardData = [];
  //       console.log(this.rows)

  //       let headers = new Headers({
  //           'Content-Type': 'application/json',
  //           apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y',
  //           'access-token': this.sessionHandler.getItem('token')

  //       });
  //       let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });

  //       return this.http1
  //           .post(path, JSON.stringify(this.dashboardData), options)
  //           .map((response: Response) => <Blob>response.blob());
  //   }

  public extractFile() {
    this.showLoader();
  
    const exportItems = (this.rows || []).map(r => {
      const o = r.original || {};
  
      return {
        sapFOCNo: o.sapFOCNo || o.sapOrderId || o.orderId || null,
        soldTo: o.soldTo || o.tradePartnerId || null,
        createdOn: this._formatDateForExport(o.createdOn || o.creationDate || o.entryDate),
        createdBy: o.createdBy ? String(o.createdBy).trim() : null,
        orderReason: o.returnReasonDesc || o.orderReason || o.reason || null,
        status: o.status ? String(o.status).toUpperCase() : null,
        level1Approver: o.level1Approver || null,
        level2Approver: o.level2Approver || null,
        entryDate: this._formatDateForExport(o.entryDate || o.createdOn || null)
      };
    });
  
    const payload = {
      items: exportItems,
      itemCount: exportItems.length
    };
  
    this.getFile(this.fileURL, payload).subscribe(
      (fileData: Blob) => {
        this.hideLoader();
        const fileName = "extract_file_" + Date.now() + ".xlsx";
        saveAs(fileData, fileName);
      },
      err => {
        this.hideLoader();
        const dlg = this.dialog.open(dialogComponent);
        dlg.componentInstance.msg = 'Failed to export file.';
        this.http.onEnd();
      }
    );
  }
  

  
  public getFile(path: string, payload: any): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y',
      'access-token': this.sessionHandler.getItem('token')
    });
  
    const options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Blob
    });
  
    return this.http1
      .post(path, JSON.stringify(payload), options)
      .map((res: Response) => <Blob>res.blob());
  }
  

  
  private _formatDateForExport(input: any): string | null {
    if (!input) return null;
    const d = new Date(input);
    return isNaN(d.getTime()) ? null : d.toISOString().split('T')[0];
  }
  


handleScroll(): void {
  this.tableScrolled = true;

  if (this.scrollTimer) {
    clearTimeout(this.scrollTimer);
  }

  this.scrollTimer = setTimeout(() => {
    this.tableScrolled = false;
  }, 500);
}

  /**
   * Opens the advanced search dialog modal
   */
  advanceSearch() {
    this.dialogRef = this.dialog.open(focSearchDialog, { disableClose: true });
    if (this.dialogRef && this.dialogRef.componentInstance) {
      this.dialogRef.componentInstance.reason = this.reasonList || [];
      this.dialogRef.componentInstance.isFS = false;
      this.dialogRef.componentInstance.isApprover = this.isApprover;
      this.dialogRef.componentInstance.isAdmin = this.isAdmin;
      this.dialogRef.componentInstance.isOTD = this.isOTD;
      this.dialogRef.componentInstance.isEndConsumner = this.isEndConsumner;
      this.dialogRef.componentInstance.isOrderDesk = this.isOrderDesk;
      this.dialogRef.componentInstance.isFOC_Admin = this.isFOC_Admin;
this.dialogRef.componentInstance.isFOC_Approver = this.isFOC_Approver;
this.dialogRef.componentInstance.isFOC_HR = this.isFOC_HR;
this.dialogRef.componentInstance.isFOC_Employee = this.isFOC_Employee;

    }
  }

 
  applyAdvancedFilters(payload: any) {
    console.debug('applyAdvancedFilters called:', payload);
    if (!payload) return;
  
    this.customFilters = payload.display || {};
    this.arrayKeys = Object.keys(this.customFilters || {});
    this.showFilterList = true;
  
    const backendFilter: any = {};
  
    // copy only known filter keys (don't include page/size/userRoles)
    const src = payload.filters || {};
  
    // status -> single enum or null
    if (src.status && Array.isArray(src.status)) {
      backendFilter.status = src.status.length ? String(src.status[0]).trim().toUpperCase() : null;
    } else if (src.status) {
      backendFilter.status = String(src.status).trim().toUpperCase();
    } else {
      backendFilter.status = null;
    }
  
    // startDate / endDate -> convert to ISO Z (keep time 00:00:00.000Z)
    const toIsoZ = (d: any) => {
      if (!d) return null;
      const date = new Date(d);
      if (isNaN(date.getTime())) return null;
      // keep only date part at midnight UTC to match your example timestamps
      const iso = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 7, 7, 5)).toISOString();
      // if you prefer start of day in UTC use: new Date(Date.UTC(...,0,0,0))
      return iso;
    };
    backendFilter.startDate = toIsoZ(src.startDate) || null;
    backendFilter.endDate = toIsoZ(src.endDate) || null;
  
    // sapFOCNo if provided in filters or display
    backendFilter.sapFOCNo = src.sapFOCNo || src.sapFOCNoStr || (payload.display && payload.display['FOC No']) || null;
  
    // map customer -> customerNo (not soldTo)
    let cust = null;

    if (src.tradePartnerId && src.tradePartnerId !== '') {
      cust = String(src.tradePartnerId).trim();
    } else if (payload.display['Customer number']) {
      cust = String(payload.display['Customer number']).trim();
    }
    
    backendFilter.customerNo = cust ? cust : null;
    
  
    // orderReasonId from reasonCode if present
    backendFilter.orderReasonId = src.reasonCode !== undefined ? src.reasonCode : null;
  
    // createdBy: only if explicitly provided; otherwise null
    backendFilter.createdBy = (src.createdBy !== undefined && src.createdBy !== null && String(src.createdBy).trim() !== '') ?
      String(src.createdBy).trim() : null;
  
    // final shape debug
    console.debug('applyAdvancedFilters -> backendFilter (to send):', backendFilter);

    this.currentAdvancedFilter = JSON.parse(JSON.stringify(backendFilter));
  this.page.pageNumber = 1;
    // call fetchPage: pass as extraFilters but do NOT add page/size into body
    this.fetchPage(1, this.page.size, '', this.currentAdvancedFilter);
  }
  
  
  
  

  /**
   * Reset advanced filters (UI + server)
   */
  resetFilters() {
  this.showFilterList = false;
  this.customFilters = {};
  this.arrayKeys = [];
  this.currentAdvancedFilter = null;
  this.page.pageNumber = 1;

  this.fetchPage(1, this.page.size, '');
}
}

/* -------------------------------------------------------------------------- */
/*                              SEARCH DIALOG CLASS                           */
/* -------------------------------------------------------------------------- */
import { MdDialogRef } from "@angular/material";


@Component({
  template: require('./focSearch.component.html'),
  providers: [HttpService, SessionHandler]
})
export class focSearchDialog implements OnInit {
  searchForm: FormGroup;
  searchParams: any = { display: {}, filters: { status: [] } };
  statusList: any[] = [];
  shipment: any[] = ['Parcel', 'Pallet'];
  reason: any[] = [];
  return_reason: any;
  daterange: any = {};
  isAdmin = false;
  isOTD = false;
  isOrderDesk = false;
  isEndConsumner = false;
  isApprover = false;
  isFOC_Admin = false;
isFOC_Approver = false;
isFOC_HR = false;
isFOC_Employee = false;
isFocUser = false;
  dialogRef;
  reasonList: any;
  soldToList: any[] = [];
soldToControl: FormControl = new FormControl();
filteredSoldToList: Observable<any[]>;
soldToDefinitionMap: { [id: string]: string } = {};
selectedSoldToId: string = null;
focRole: string = null;




  constructor(
    private fb: FormBuilder,
    private daterangepickerOptions: DaterangepickerConfig,
    private dialog: MdDialog,
    private commonService: CommonService,
    private http: HttpService,
    private sessionHandler: SessionHandler,


  ) {
    const today = new Date();
    const monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const start = new Date(today.getFullYear(), Math.max(0, today.getMonth()-1), today.getDate());
    const end = new Date(today.getFullYear(), Math.min(11, today.getMonth()+1), today.getDate());
    this.searchParams.display['Date Interval'] =
      monthNames[start.getMonth()] + ' ' + start.getDate() + ' ' + start.getFullYear() + ' - ' +
      monthNames[end.getMonth()] + ' ' + end.getDate() + ' ' + end.getFullYear();
    this.searchParams.filters.startDate = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate();
    this.searchParams.filters.endDate = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate();
    this.daterangepickerOptions.settings = {
      locale: { format: 'YYYY-MMM-D' },
      opens: 'center'
    };
    /* ------------ ROLE LOGIC (same as FOC Create / Confirm / Dashboard) ------------ */

const loginData = JSON.parse(this.sessionHandler.getItem('loginData') || '{}');
const roles: string[] =
  (loginData && Array.isArray(loginData.role)) ? loginData.role : [];

// New FOC roles
this.isFOC_Admin     = roles.indexOf('FOC_ADMINISTRATOR') !== -1;
this.isFOC_Approver  = roles.indexOf('FOC_APPROVER') !== -1;
this.isFOC_HR        = roles.indexOf('FOC_HR') !== -1;
this.isFOC_Employee  = roles.indexOf('FOC_EMPLOYEE') !== -1;

if (this.isFOC_Admin) {
  this.focRole = 'FOC_ADMINISTRATOR';
} else if (this.isFOC_Approver) {
  this.focRole = 'FOC_APPROVER';
} else if (this.isFOC_HR) {
  this.focRole = 'FOC_HR';
} else if (this.isFOC_Employee) {
  this.focRole = 'FOC_EMPLOYEE';
}

// Any FOC user flag
this.isFocUser =
  this.isFOC_Admin ||
  this.isFOC_Approver ||
  this.isFOC_HR ||
  this.isFOC_Employee;

// Existing roles
this.isAdmin        = roles.indexOf('ADMIN') !== -1;
this.isOTD          = roles.indexOf('OTD_APPROVER') !== -1 || this.isFOC_Approver;
this.isOrderDesk    = roles.indexOf('ORDER_DESK_AGENT') !== -1;
this.isEndConsumner = roles.indexOf('END_CONSUMER') !== -1;
this.isApprover     = roles.indexOf('APPROVER') !== -1;

this.getReasonList();


  }


  ngOnInit() {
    this.statusList = [
      { text: 'Pending', id: 'PENDING' },
      { text: 'Level 1 Approved', id: 'LEVEL1_APPROVED' },
      { text: 'Level 2 Approved', id: 'LEVEL2_APPROVED' },
      { text: 'Rejected', id: 'REJECTED' },
      { text: 'Incomplete FOC Request', id: 'INCOMPLETE_FOC_REQUEST' },
      { text: 'Error', id: 'ERROR' },



  
    ];
    this.buildForm();
    this.getSoldToList();     
  }

  buildForm() {
    this.searchForm = this.fb.group({
      status: [[]],
      sapFOCNo: [''],
      shipmentType: [''],
      reasonCode: [''],
      createdBy: [''],
      tradePartnerId: [''],
      serialNumber: [''],
      returnReference: ['']
    });
  }

  selectedDate(value: any) {
    if (!value || !value.start || !value.end) return;
    this.searchParams.filters.startDate = value.start.format('YYYY-MM-DD');
    this.searchParams.filters.endDate = value.end.format('YYYY-MM-DD');
    this.searchParams.display['Date Interval'] = value.start.format('MMMM D YYYY') + ' - ' + value.end.format('MMMM D YYYY');
  }

  public getSoldToList() {
    const roleQuery = this.focRole ? `?role=${this.focRole}` : '';

    this.http.getRequest('focApi/v1/getFOCSoldToList' + roleQuery)      .subscribe((res: any) => {         
        if (res && Array.isArray(res.soldToList)) {
          this.soldToDefinitionMap = {};
          const unique: { [id: string]: boolean } = {};
          const ids: string[] = [];
  
          res.soldToList.forEach(it => {
            if (!it || !it.soldTo) return;
            const id = String(it.soldTo);
  
            if (!unique[id]) {
              unique[id] = true;
              ids.push(id);
            }
  
            this.soldToDefinitionMap[id] = it.soldToDefinition || '';
          });
  
          this.soldToList = ids;
        }
  
        this.setupSoldToFilter();
      });
  }
  
  

  private setupSoldToFilter() {
    this.filteredSoldToList = this.soldToControl.valueChanges.pipe(
      startWith(''),
      debounceTime(150),
      map(value => this._filterSoldTo(value))
    );
  }
  
  private _filterSoldTo(value: any): any[] {
    if (!this.soldToList || this.soldToList.length === 0) return [];
  
    const term = String(value || '').toLowerCase();
  
    return this.soldToList.filter(id => {
      const idStr = id.toLowerCase();
      const defStr = (this.soldToDefinitionMap[id] || '').toLowerCase();
      return idStr.includes(term) || defStr.includes(term);
    });
  }
  

  public soldToOptionSelected(event: any, id: string) {
    if (!event.isUserInput) return;  // only when user selects it
  
    this.selectedSoldToId = id;
    this.soldToControl.setValue(id);
    this.searchForm.get('tradePartnerId').setValue(id);
  }
  
  
  

  public onSoldToBlur(): void {
    const val = this.soldToControl.value;
  
    if (!val) {
      this.searchForm.get('tradePartnerId').setValue(null);
      return;
    }
  
    this.searchForm.get('tradePartnerId').setValue(val);
  }
  
  
    
  
  selected(value: any) {
    if (!value) return;
    this.searchParams.filters.status.push(value.id);
    if (!this.searchParams.display.Status) this.searchParams.display.Status = [];
    this.searchParams.display.Status.push(value.text);
  }

  removed(value: any) {
    const idx = this.searchParams.filters.status.indexOf(value.id);
    if (idx >= 0) this.searchParams.filters.status.splice(idx, 1);
    if (this.searchParams.display.Status) {
      const idx2 = this.searchParams.display.Status.indexOf(value.text);
      if (idx2 >= 0) this.searchParams.display.Status.splice(idx2, 1);
    }
  }

  public getReasonList() {

  
    this.http.getRequest('focApi/v1/getOrderReasons' + (this.focRole ? `?role=${this.focRole}` : ''))
    .subscribe(
        res => {
          console.log('getReasonList() raw response:', res);
          this.saveReasonList(res);
        },
        err => {
          if (err && err.status != 0) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = err;
          }
          this.http.onEnd();
        }
      );
  }
  
  

  public saveReasonList(res) {
    console.log('saveReasonList() called with:', res); // debug
  
    try {
      if (!res) {
        throw new Error('Empty response');
      }
  
      let list = null;
  
      // new format: { orderReasons: [ { id, reasonDefinition, sapCode } ] }
      if (res.orderReasons && Array.isArray(res.orderReasons)) {
        list = res.orderReasons.map(r => ({
          reasonCode: (r.reasonCode !== undefined ? String(r.reasonCode) : (r.id !== undefined ? String(r.id) : '')),
          // map reasonDefinition -> reason (fallbacks to other fields)
          reason: (r.reason !== undefined ? r.reason : (r.reasonDefinition !== undefined ? r.reasonDefinition : (r.description || '')))
        }));
      }
      // new format: { reasonDefinition: [...] }  (kept from your original)
      else if (res.reasonDefinition && Array.isArray(res.reasonDefinition)) {
        list = res.reasonDefinition.map(r => ({
          reasonCode: (r.reasonCode !== undefined ? String(r.reasonCode) : (r.id !== undefined ? String(r.id) : '')),
          reason: (r.reason !== undefined ? r.reason : '')
        }));
      }
      // old format: { items: [...] }
      else if (res.items && Array.isArray(res.items)) {
        list = res.items.map(r => ({
          reasonCode: (r.reasonCode !== undefined ? String(r.reasonCode) : (r.id !== undefined ? String(r.id) : '')),
          reason: (r.reason !== undefined ? r.reason : (r.description || ''))
        }));
      }
      // fallback: top-level array
      else if (Array.isArray(res)) {
        list = res.map(r => ({
          reasonCode: (r.reasonCode !== undefined ? String(r.reasonCode) : (r.id !== undefined ? String(r.id) : '')),
          reason: (r.reason !== undefined ? r.reason : (r.description || ''))
        }));
      }
  
      if (list && list.length > 0) {
        this.reasonList = list;
        this.sessionHandler.saveItem('reasons', JSON.stringify(this.reasonList));
        this.http.onEnd();
        console.log('Normalized reasonList saved:', this.reasonList);
      } else {
        // fallback: if API returned a shape we didn't expect, print it and show error
        console.error('saveReasonList: could not normalize response. raw:', res);
        const dlg = this.dialog.open(dialogComponent);
        dlg.componentInstance.msg = 'Not able to fetch reason list.';
        this.http.onEnd();
      }
    } catch (e) {
      console.error('saveReasonList error:', e, res);
      const dlg = this.dialog.open(dialogComponent);
      dlg.componentInstance.msg = 'Not able to fetch reason list.';
      this.http.onEnd();
    }
  }
  

  search() {
    const data = this.searchForm.getRawValue();
  
if (data.sapFOCNo) {
  this.searchParams.filters.sapFOCNo = String(data.sapFOCNo).trim();
  this.searchParams.display['FOC Order ID'] = String(data.sapFOCNo).trim();
}
    const selected = this.searchForm.get('tradePartnerId').value;
if (selected && selected !== '') {
  this.searchParams.filters.tradePartnerId = String(selected).trim();
  this.searchParams.display['Customer number'] = String(selected).trim();
}

    if (data.reasonCode) {
      this.searchParams.filters.reasonCode = data.reasonCode;
      // find the reason text if available
      let foundText = data.reasonCode;
      for (let i = 0; i < (this.reason || []).length; i++) {
        if (this.reason[i].reasonCode === data.reasonCode) {
          foundText = this.reason[i].reason;
          break;
        }
      }
      this.searchParams.display['Reason'] = foundText;
    }
    if (data.createdBy) {
      this.searchParams.filters.createdBy = data.createdBy;
      this.searchParams.display['Created By'] = data.createdBy;
    }
    if (data.serialNumber) {
      this.searchParams.filters.serialNumber = data.serialNumber;
      this.searchParams.display['Serial number'] = data.serialNumber;
    }
    if (data.returnReference) {
      this.searchParams.filters.returnReference = data.returnReference;
      this.searchParams.display['Return Reference'] = data.returnReference;
    }

    console.log(
      "tradePartnerId in form:", this.searchForm.get('tradePartnerId').value,
      "soldToControl:", this.soldToControl.value
    );
    

    // Publish payload through commonService (caller listens to searchChange)
    if (this.commonService && this.commonService.changeSearchData) {
      this.commonService.changeSearchData(this.searchParams);
    } else if (this.commonService && this.commonService.searchChange) {
      // fallback if your service uses a subject instead of method
      try {
        (this.commonService.searchChange as any).next(this.searchParams);
      } catch (e) {
        // ignore if not available
      }
    }
    this.dialog.closeAll();
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}


/*download dialog*/

import { ErrorHandler } from '../shared/services/error-handler.service'
import * as $ from 'jquery';
import { debounceTime, distinctUntilChanged, filter, map, startWith, take } from 'rxjs/operators';

@Component({
    template: require('./foc-download.component.html'),
    providers: [HttpService, ErrorHandler, SessionHandler]
})
export class focDownloadComponent implements OnInit {
    urlList: any = [];
    uploader;
    fileUploadResponse: any;
    isFileUploaded: boolean = false;
    isFileUploadError: boolean = false;
    URL: any = APPCONFIG.appUrlBase + '/uploadFiles';
    fileUrl: any = [];
    requestNo: string;
    fileProcessStart: boolean = false;
    token;
    constructor(private formBuilder: FormBuilder, public dialog: MdDialog, private commonService: CommonService,
        private http: HttpService, private http1: Http, private sessionHandler: SessionHandler, private router: Router
    ) {
        this.token = this.sessionHandler.getItem('token');
        if (this.http.checkSession()) {
            this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });

        } else {
            this.http.showSessionError();
        }
    }
    ngOnInit(): void {
        this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
    }

    public buildForm() {

    }


    public closeDialog() {
        this.dialog.closeAll();
        if (this.isFileUploaded) {
            window.location.reload();
        }
    }

    public fileupload() {
        this.fileProcessStart = true;
        let formData = new FormData();
        for (let i in this.uploader.queue) {
            this.http.showLoader();
            this.isFileUploaded = true;
            formData.append('file', this.uploader.queue[i]._file);
            let headers = new Headers({
                'apiKey': 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y', 'requestNo': this.requestNo, 'access-token': this.sessionHandler.getItem('token')
            });
            this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
            this.http1
                .post(this.URL, formData, { headers: headers })
                .toPromise()
                .then(res => this.setUploadData(res.json()))
                .catch(error => this.handleError(error))
        }
    }

    public handleError(e) {
        //this.showError(e, false);
        console.log('error found -- file upload....' + e);
        this.fileUploadResponse = e;
        this.fileProcessStart = false;
        this.isFileUploadError = true;
        this.http.onEnd();
    }

    public setUploadData(res) {
        this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
        if (res.responseCode == 200) {
            this.isFileUploadError = false;
            //this.fileUrl.push(res.fileUrl);
            this.fileUploadResponse = res.message;
        } else if (res.responseCode == 400) {
            this.isFileUploadError = true;
            this.fileUploadResponse = res.message;
        }
        this.fileProcessStart = false;
        this.http.onEnd();
    }

    
    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/foc-dashboard/foc-dashboard.component.ts